import type { ReactNode } from "react";

/**
 * The page's editorial content block. Rendered once per page by the shared
 * layouts (ToolLayout, GuideLayout), never by a page directly.
 *
 * Direct children must be flat p, h2, h3, ul, ol, figure, details, or a
 * <div className="table-scroll"> holding one table. No wrapper divs, grids,
 * cards, tabs or interactive tool UI, and no inline styles. Typography comes
 * from the .content-block rules in styles.css.
 *
 * Text must be written so React emits no hydration comments inside the
 * block: never put a JSX expression ({x}, {" "}) right next to plain text.
 */
export function ContentBlock({ children }: { children: ReactNode }) {
  return (
    <div id="mv-content" className="content-block">
      {children}
    </div>
  );
}

/** Horizontal-scroll wrapper for tables inside the content block. */
export function TableScroll({ children }: { children: ReactNode }) {
  return <div className="table-scroll">{children}</div>;
}
